import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Link/Link.js'

export default class NotAuthorized extends WebComponent {

  get translationFile() {
    return './views/NotAuthorized/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.render()
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('not.authorized.title')}">
      </isceco-title>
      <isceco-link text="${this.i18n.translate('not.authorized.startseite')}" url=" ">
      </isceco-link>
    `
  }
}
customElements.define('eko-frontend-not-authorized', NotAuthorized)
